// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"be154ffd1fc6707cd594","135":"6502097052d6ab6d3130","136":"d6008a64b0064de0db3f","174":"4190a854f4bc3e2bc3eb"}[chunkId] + ".chunk.js";
};